import React from "react";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { useThemeMode } from "../../context/ThemeContext";
import lightLogo from "../../assets/light-logo.png";
import darkLogo from "../../assets/dark-logo.png";

type LogoLinkProps = {
  width?: number;
  height?: number;
};

const LogoLink: React.FC<LogoLinkProps> = ({ width = 130, height = 70 }) => {
  const { mode } = useThemeMode();

  return (
    <Box
      component={Link}
      to="/"
      sx={{
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
      }}
    >
      <img
        src={mode === "dark" ? darkLogo : lightLogo}
        alt="Logo"
        style={{
          width,
          height,
          objectFit: "contain",
          transition: "transform 0.3s ease",
          cursor: "pointer",
        }}
        onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
      />
    </Box>
  );
};

export default LogoLink;


